import { CountryDictionaryItem } from '@/models/dictionary/country';
import { ICountryDictionaryApi } from '@/types';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';

export const useCountryDictionary = defineStore('countryDictionary', () => {
    const items = shallowRef<CountryDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: ICountryDictionaryApi[]) {
        console.time('set-country-dictionary');
        items.value = data.map((item) => new CountryDictionaryItem(item));
        console.timeEnd('set-country-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
